export default {"src":"/_next/static/media/heart.83e6b3a3.svg","height":19,"width":21};